import React, { useState } from "react";
import { Grid, Switch } from "@material-ui/core";
import useStyles from "./styles";
import { UserDetailsTableProps } from "./types";
import BarChart from "../../components/BarChart";
import StatTable from "../../components/StatTable";
import { Currency } from "../../../../components/misc/Currency";
import { useI18n } from "../../../../hooks/useI18n";

const UserDetailsTable = ({
  title,
  users,
  isLoading,
  displayGraphSwitch
}: UserDetailsTableProps) => {
  const classes = useStyles();
  const { t } = useI18n();

  const [showGraph, setShowGraph] = useState(false);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setShowGraph(event.target.checked);
  };

  return (
    <div>
      {displayGraphSwitch ? (
        <Grid
          className={
            showGraph
              ? classes.switchContainer
              : classes.switchContainerAbsolute
          }
          component="label"
          container
          justifyContent="flex-start"
          alignItems="center"
          spacing={1}
        >
          <Grid item>{t("common.messages.table")}</Grid>
          <Grid item>
            <Switch
              size={"small"}
              checked={showGraph}
              onChange={handleChange}
              name="graphSwitch"
            />
          </Grid>
          <Grid item>{t("common.messages.chart")}</Grid>
        </Grid>
      ) : (
        <></>
      )}
      {showGraph ? (
        <BarChart
          chartData={{
            labels: users.map((p: { name: any }) => p.name),
            datasets: [
              {
                label: "Sales",
                rgbColor: { r: 0, g: 148, b: 148 },
                data: users.map((p: { sales: any }) => p.sales)
              },
              {
                label: "Sales by women",
                rgbColor: { r: 58, g: 160, b: 75 },
                data: users.map((p: { salesWomen: any }) => p.salesWomen)
              },
              {
                label: "Sales by men",
                rgbColor: { r: 5, g: 89, b: 141 },
                data: users.map((p: { salesMen: any }) => p.salesMen)
              }
            ]
          }}
          showLegend={true}
          isLoading={isLoading}
        />
      ) : (
        <StatTable
          isLoading={isLoading}
          exportName={`User sales by ${title}`}
          columns={[
            {
              title: title,
              field: "name",
              cellStyle: { padding: "8px" },
              defaultSort: "asc"
            },
            {
              title: "Sales",
              field: "sales",
              cellStyle: { padding: "8px", borderLeft: "1px solid #e9e5e2" },
              render: (rowData: any) => <Currency value={rowData.sales} />
            },
            {
              title: t("common.tableHeaders.byWomen"),
              field: "salesWomen",
              cellStyle: { padding: "8px" },
              render: (rowData: any) => <Currency value={rowData.salesWomen} />
            },
            {
              title: t("common.tableHeaders.byMen"),
              field: "salesMen",
              cellStyle: { padding: "8px" },
              render: (rowData: any) => <Currency value={rowData.salesMen} />
            },
            {
              title: "Quantity",
              field: "quantity",
              cellStyle: { padding: "8px", borderLeft: "1px solid #e9e5e2" }
            },
            {
              title: t("common.tableHeaders.byWomen"),
              field: "quantityWomen",
              cellStyle: {
                padding: "8px"
              }
            },
            {
              title: t("common.tableHeaders.byMen"),
              field: "quantityMen",
              cellStyle: {
                padding: "8px"
              }
            }
          ]}
          data={users}
          dense
        />
      )}
    </div>
  );
};
export default UserDetailsTable;
